module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-76x76.ae78a833e7e0fdb168e683ad8d90b546.png";